import React from 'react';
import Icon from '@/components/ui/Icon';
import cn from '@/utils/cn';
import {
  PASSWORD_COMPLEXITY_REGEX,
  STRONG_PASSWORD_COMPLEXITY_MESSAGE,
  STRONG_PASSWORD_LENGTH_MESSAGE,
} from './helpers';

const Requirement = ({ isFulfilled, maxWidth, text }: { isFulfilled: boolean; maxWidth?: number; text: string }) => {
  const iconSize = 12;
  // Adjust maxWidth to account for icon size and margin
  const maxWidthStyle = maxWidth != null ? { maxWidth: `${maxWidth - iconSize - 4}px` } : undefined;

  return (
    <div className={cn(
      'tw-flex tw-text-red',
      { 'tw-text-green': isFulfilled },
    )}
    >
      <Icon
        className="tw-inline tw-mr-1 tw-mt-1"
        icon={isFulfilled ? 'Check' : 'Close'}
        size={iconSize}
      />
      <span style={maxWidthStyle}>{text}</span>
    </div>
  );
};

type PasswordRequirementsProps = {
  maxWidth?: number;
  password?: string;
  spacerWidth?: number;
  wrapperClassName?: string;
};

const PasswordRequirements = ({ maxWidth, password, spacerWidth, wrapperClassName }: PasswordRequirementsProps) => {
  const hasPassword = (password || '').length > 0;
  const hasMinLength = password && password.length >= 8;
  const hasComplexity = password && PASSWORD_COMPLEXITY_REGEX.test(password);

  return (
    <div className={cn('tw-flex tw-items-center', wrapperClassName || '')}>
      <div
        className={cn(
          'tw-text-sm tw-transition-all tw-duration-300 tw-ease-in-out tw-overflow-hidden',
          hasPassword ? 'tw-opacity-100 tw-max-h-32 tw-mt-2 tw-mb-3' : 'tw-opacity-0 tw-max-h-0',
        )}
        style={{ marginLeft: spacerWidth ? `${spacerWidth}px` : undefined }}
      >
        <Requirement
          isFulfilled={hasMinLength}
          maxWidth={maxWidth}
          text={STRONG_PASSWORD_LENGTH_MESSAGE}
        />
        <Requirement
          isFulfilled={hasComplexity}
          maxWidth={maxWidth}
          text={STRONG_PASSWORD_COMPLEXITY_MESSAGE}
        />
      </div>
    </div>
  );
};

export default PasswordRequirements;
